export function registerEditorCommands (editor, { onFormat }) {
  const commands = [
    {
      name: 'abundanceFind',
      bindKey: { win: 'Ctrl-F', mac: 'Command-F' },
      exec: loadedEditor => loadedEditor.execCommand('find'),
      readOnly: true
    },
    {
      name: 'abundanceReplace',
      bindKey: { win: 'Ctrl-H', mac: 'Command-Alt-F' },
      exec: loadedEditor => loadedEditor.execCommand('replace'),
      readOnly: false
    },
    {
      name: 'abundanceFindNext',
      bindKey: { win: 'Ctrl-G', mac: 'Command-G' },
      exec: loadedEditor => loadedEditor.findNext(),
      readOnly: true
    },
    {
      name: 'abundanceFindPrevious',
      bindKey: { win: 'Ctrl-Shift-G', mac: 'Command-Shift-G' },
      exec: loadedEditor => loadedEditor.findPrevious(),
      readOnly: true
    },
    {
      name: 'abundanceRedo',
      bindKey: { win: 'Ctrl-Y|Ctrl-Shift-Z', mac: 'Command-Shift-Z' },
      exec: loadedEditor => loadedEditor.redo(),
      readOnly: false
    },
    {
      name: 'abundanceUndo',
      bindKey: { win: 'Ctrl-Z', mac: 'Command-Z' },
      exec: loadedEditor => loadedEditor.undo(),
      readOnly: false
    },
    {
      name: 'abundanceSelectNextOccurrence',
      bindKey: { win: 'Ctrl-D', mac: 'Command-D' },
      exec: loadedEditor => loadedEditor.execCommand('selectMoreAfter'),
      readOnly: true
    },
    {
      name: 'abundanceAddCursorAbove',
      bindKey: { win: 'Ctrl-Alt-Up', mac: 'Command-Option-Up' },
      exec: loadedEditor => loadedEditor.execCommand('addCursorAbove'),
      readOnly: true
    },
    {
      name: 'abundanceAddCursorBelow',
      bindKey: { win: 'Ctrl-Alt-Down', mac: 'Command-Option-Down' },
      exec: loadedEditor => loadedEditor.execCommand('addCursorBelow'),
      readOnly: true
    },
    {
      name: 'abundanceFormat',
      bindKey: { win: 'Shift-Alt-F', mac: 'Shift-Option-F' },
      exec: async () => {
        if (onFormat) {
          await onFormat()
        }
      },
      readOnly: false
    }
  ]

  commands.forEach(command => {
    editor.commands.addCommand(command)
  })
}
